import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { IsAlreadyLoggedInGuard, IsLoggedInGuard } from '@elio/emanager-front/auth/shared';
import { UserService } from '@elio/emanager-front/auth/state';
import { CustomRoute } from '@elio/emanager-front/shared/tools/router';
import { map } from 'rxjs';

export const tokenGuard = (next: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const email = next.queryParams['email'];
  const token = next.queryParams['token'];
  return inject(UserService)
    .getChangeMyPasswordTokenValidation(email, token)
    .pipe(
      map((tokenValidation) => {
        if (tokenValidation === 'TOKEN_VALID') {
          return true;
        } else if (tokenValidation === 'TOKEN_EXPIRED') {
          return router.navigate(['/', 'login', 'expired-token'], { state: { email } });
        } else {
          return router.navigate(['/', 'login']);
        }
      })
    );
};

export const routes: CustomRoute[] = [
  {
    path: 'login',
    canMatch: [IsAlreadyLoggedInGuard],
    loadComponent: () => import('@elio/emanager-front/auth/feature').then((c) => c.LandingPageComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('@elio/emanager-front/auth/feature').then((c) => c.LoginComponent),
      },
      {
        path: 'password',
        loadComponent: () => import('@elio/emanager-front/auth/feature').then((c) => c.ForgottenPasswordComponent),
      },
      {
        path: 'confirmation',
        loadComponent: () =>
          import('@elio/emanager-front/auth/feature').then((c) => c.ForgottenPasswordConfirmationComponent),
      },
      {
        path: 'reset-password',
        children: [
          {
            path: 'validation',
            canActivate: [tokenGuard],
            loadComponent: () => import('@elio/emanager-front/auth/feature').then((c) => c.DefinePasswordComponent),
          },
        ],
      },
      {
        path: 'define-password',
        canActivate: [tokenGuard],
        loadComponent: () => import('@elio/emanager-front/auth/feature').then((c) => c.DefinePasswordComponent),
      },
      {
        path: 'expired-token',
        loadComponent: () => import('@elio/emanager-front/auth/feature').then((c) => c.ExpiredTokenComponent),
      },
    ],
  },
  {
    path: 'login',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '404',
    loadComponent: () => import('@elio/emanager-front/error').then((mod) => mod.Error404Component),
  },
  {
    path: '403',
    loadComponent: () => import('@elio/emanager-front/error').then((mod) => mod.Error403Component),
  },
  {
    path: 'offer-empty',
    loadComponent: () => import('@elio/emanager-front/offer/empty-modal').then((c) => c.OfferEmptyComponent),
    outlet: 'popup',
  },
  {
    path: '',
    canMatch: [IsLoggedInGuard],
    loadChildren: () => import('./main-shell/main-shell.module').then((mod) => mod.MainShellModule),
    data: {
      preload: true,
    },
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  { path: '**', redirectTo: '404' },
];
